export const gateway = "https://sbx-cmf-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://sbx-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=3phcvfq48dtputatl4l6f000sv&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fsbx-cmf-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://sbx-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "3phcvfq48dtputatl4l6f000sv";
export const BrokerPoolDomainParameter = "sbx-brokers";
export const BrokerPoolParameter = "ca-central-1_6MtXxTkqE";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://sbx-cmf-shopper.link-nonprod.wawanesalife.com";

//updated on Tue May 13 2025 11:09:49 GMT-0500 (Central Daylight Time)
